// NOTE: no mapbox-gl.css import here — this is the Remotion entry point and the
// headless canvas render doesn't need it (tripmovie renders map scenes without it
// too). The plain-.css import also breaks @remotion/bundler's nested css-loader.
// The app loads mapbox CSS itself in App.tsx.
import { registerRoot } from "remotion";
// import TikTokVideo from "./TikTokVideo";
import MapImage from "./MapImage";
registerRoot(MapImage);
